var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28.000000000000004,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 30,
    width: 24,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#ac4b1c",
    d: "m11,28c-6.1,0 -11,-4.9 -11,-11c0,-5.8 4.6,-17 11,-17s11,11.2 11,17c0,6.1 -4.9,11 -11,11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggIcon);
export default __webpack_public_path__ + "static/media/egg-icon.b6c665894ef6dd3f0fbe23b00c40e3c4.svg";
export { ForwardRef as ReactComponent };